import { Injectable } from '@angular/core';
import { AuthStore } from '@store';
import { AssistantApi } from '@vi-iot/client/apis/assistant/assistant.api';
import { AssistantMockApi } from '@vi-iot/client/apis/assistant/assistant.mock.api';
import { BaseApiPickerImpl } from '@vi-iot/client/apis/base.api-picker';

@Injectable({ providedIn: 'root' })
export class AssistantApiPicker extends BaseApiPickerImpl<AssistantApi | AssistantMockApi> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: AssistantApi,
    protected mockApi: AssistantMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
